<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6406_2915)">
<path d="M21.4646 40.0678C19.2135 42.1199 16.0625 43.397 12.5784 43.397C5.7532 43.397 0.430311 37.0466 0.199924 31.0705C-0.25605 19.1041 23.1906 0.638403 24.1937 0C25.1921 0.638403 48.6435 19.1041 48.1876 31.0705C47.9572 37.0466 42.6343 43.397 35.8091 43.397C31.8035 43.397 28.2335 41.7059 25.9689 39.0888C26.7233 42.203 27.9872 45.2064 29.7288 47.9952H17.9534C19.5155 45.5023 20.6935 42.8342 21.4646 40.0678Z" fill="url(#paint0_linear_6406_2915)"/>
<path d="M29.7288 47.9952L29.7318 48V47.9952H29.7288Z" fill="url(#paint1_linear_6406_2915)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M32.8423 17.166C33.543 17.8229 33.5785 18.9235 32.9216 19.6242L21.2584 32.065L15.1188 25.9254C14.4396 25.2462 14.4396 24.145 15.1188 23.4659C15.7979 22.7867 16.8991 22.7867 17.5783 23.4659L21.1778 27.0654L30.3841 17.2453C31.041 16.5446 32.1416 16.5091 32.8423 17.166Z" fill="white"/>
</g>
<defs>
<linearGradient id="paint0_linear_6406_2915" x1="24.1937" y1="0" x2="24.1937" y2="48" gradientUnits="userSpaceOnUse">
<stop stop-color="#5BC4FF"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<linearGradient id="paint1_linear_6406_2915" x1="24.1937" y1="0" x2="24.1937" y2="48" gradientUnits="userSpaceOnUse">
<stop stop-color="#5BC4FF"/>
<stop offset="1" stop-color="#480D93"/>
</linearGradient>
<clipPath id="clip0_6406_2915">
<rect width="48" height="48" fill="white"/>
</clipPath>
</defs>
</svg>
